import React, { useEffect } from 'react';
import { motion } from 'framer-motion';

const colorStyles = {
  info: {
    // bg: '#002B49',
    bg: '#020f35',
    accent: '#00BFFF'
  },
  warning: { bg: '#3C2F00', accent: '#FFBF00' },
  error: { bg: '#420000', accent: '#FF4C4C' },
};

const animations = {
  slide: { initial: { x: 300 }, animate: { x: 0 }, exit: { x: 300 } },
  fade: { initial: { opacity: 0 }, animate: { opacity: 1 }, exit: { opacity: 0 } },
  zoom: { initial: { scale: 0.5 }, animate: { scale: 1 }, exit: { scale: 0.5 } },
  bounce: {
    initial: { y: 100, opacity: 0 },
    animate: { y: 0, opacity: 1, transition: { type: 'spring', stiffness: 300 } },
    exit: { y: 100, opacity: 0 },
  }
};

const truncate = (text, maxLength) =>
  text.length > maxLength ? text.slice(0, maxLength - 3) + '...' : text;

const Toast = ({ id, title, message, type = 'info', duration = 4000, animation = 'slide', onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => onClose(id), duration);
    return () => clearTimeout(timer);
  }, [id, duration, onClose]);

  const { bg, accent } = colorStyles[type];
  const anim = animations[animation] || animations.slide;


  return (
    <motion.div
      initial={anim.initial}
      animate={anim.animate}
      exit={anim.exit}
      style={{
        background: bg,
        borderLeft: `5px solid ${accent}`,
        color: '#fff',
        borderRadius: '8px',
        padding: '12px 16px',
        marginTop: '10px',
        minWidth: '280px',
        maxWidth: '360px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
        pointerEvents: 'auto',
        overflowWrap: 'break-word',
        wordWrap: 'break-word',
      }}
    >
      <strong
        title={title}
        style={{ color: accent, display: 'block', marginBottom: 4 }}
      >
        {truncate(title, 60)}
      </strong>
      <div title={message}>
        {truncate(message, 200)}
      </div>
    </motion.div>
  );
};

export default Toast;
